import firebase from 'firebase';
import  firebaseConfig  from './firebaseConfig';
firebase.initializeApp(firebaseConfig);
export default firebase;